export default {
  mounted() {
    const input = this.el.querySelector('input[type="range"]');
    const display = this.el.querySelector('span');

    // Update display value in real-time while sliding
    input.addEventListener('input', (e) => {
      display.textContent = e.target.value;
    });

    // Only send event to server when done sliding
    input.addEventListener('change', (e) => {
      this.pushEvent('weeks_count_changed', { weeks_count: e.target.value });
    });
  },
};
